import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ErrorState {
    hasError: boolean;
    errorMessage: string | null;
}

const initialState: ErrorState = {
    hasError: false,
    errorMessage: null,
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError(state, action: PayloadAction<{ hasError: boolean; message: string | null }>) {
            state.hasError = action.payload.hasError;
            state.errorMessage = action.payload.message;
        },
    },
});

export const { setError } = errorSlice.actions;
export default errorSlice.reducer;
